import type { ComponentType } from "react";
import ReturnNotePdfComponent from "./ReturnNotePdf.jsx";

const ReturnNotePdf = ReturnNotePdfComponent as ComponentType<any>;
export default ReturnNotePdf;
